import React from 'react'
import './chefImage.css'

export default function chefImage() {
  return (
    <div className='chef-image-container'>
       <img src='/images/chef.jpg' alt='chef' className='chef-image' />
    </div>
  )
}
